<template>
    <v-container fluid ma-3 pa-3>
        <v-layout row wrap justify-center>
            <v-flex>
                <span class="style_title">Challenge Management</span>
                <br>
                <br>
                <div>
                    <span class="style_description" style="white-space: pre-line">In the section “Challenge Management” you can explore and manage the challenges.
The challenge list is divided in three tabs:
                        <ul>
                            <li>unpublished: created challenge but not already published</li>
                            <li>published: challenges currently valid and published to which startups can subscribe</li>
                            <li>expired: challenges whose deadline has already passed</li>
                        </ul>
</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">How to create a new challenge</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">To create a challenge you can click on the green “Create challenge” button.
You have to compile correctly all the fields. Remember that:
                        <ul>
                            <li>The title must have maximum 200 characters</li>
                            <li>You can edit the description with the style you prefer</li>
                            <li>If you want to insert more than one tag, you have separate them by clicking Enter</li>
                            <li>choose the deadline date from the calendar picker</li>
                            <li>The reward must have maximum 200 characters</li>
                            <li>upload an image of maximum 5 MB</li>
                        </ul>
When all the fields are compiled click on the blue button “Create”.
Your challenge is temporarily placed in draft status, in the 'unpublished' section.
If you want to publish it and make it visible in the public portal, click on “Edit” button in the bottom left corner of its card and then the green button “Publish”.
In this moment the system automatically send a notification to all the “similar” startups based on challenge tags, suggesting to them to subscribe a solution.

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">How to retrieve startup application data</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">If you want to monitor the startup subscriptions to a challenge, you can click on the “Startups” button to the bottom of the appropriate card.
                         <br>
                        <v-img
                                max-width="300"
                                :src="require('@/assets/img/help/exploreButton.png')"
                        >
                </v-img>
The table shows (if present) a list of registered startups on the left, and clicking on each startup, some details on the right.
For each startup you can read the main information like name and market, the pdf solution (downloadable) it has proposed and a link to startup detailed data.
 <br>
                        <v-img
                                max-width="800"
                                :src="require('@/assets/img/help/tableRegistered.png')"
                        >
                </v-img>

</span>
                </div>
                <br>


            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    export default {
        name: "ChallengeManagementHelp",
        components: {},
        data() {
            return {

            }
        },

        methods: {

        }
    }
</script>

<style scoped>
    .style_description{
        font-size: 18px;
    }

    .style_paragraph{
        font-size: 22px;
        font-weight: bold;
    }

    .style_title{
        font-size: 34px;
        font-weight: bold;
    }

</style>